// extracted by mini-css-extract-plugin
export default {"container":"Rent_container__EZABl","titulo":"Rent_titulo__8qXzq"};